import { useAxeptio } from '@/composables/_next/useAxeptio';

import type { Locale as AvailableLocales } from '@az/middleware';

export const getKlaviyoToken = (locale: AvailableLocales) => {
  const tokens = {
    fr: process.env.KLAVIYO_TOKEN_FR,
    it: process.env.KLAVIYO_TOKEN_IT,
    en: process.env.KLAVIYO_TOKEN_EN,
    de: process.env.KLAVIYO_TOKEN_DE,
    es: process.env.KLAVIYO_TOKEN_ES,
  };

  return tokens[locale] || tokens.fr;
};

export const getKlaviyoFooterId = (locale: AvailableLocales) => {
  const ids = {
    fr: process.env.KLAVIYO_SUBSCRIBE_FORM_FR,
    it: process.env.KLAVIYO_SUBSCRIBE_FORM_IT,
    en: process.env.KLAVIYO_SUBSCRIBE_FORM_EN,
    de: process.env.KLAVIYO_SUBSCRIBE_FORM_DE,
    es: process.env.KLAVIYO_SUBSCRIBE_FORM_ES,
  };

  return ids[locale] || ids.fr;
};

export const klaviyoClientSubscriptionEvent = async (email, locale, source) => {
  const response = await $fetch(`/middleware/klaviyo/client-subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      source,
      locale,
    }),
  });
  return response;
};

export const klaviyoClientUnsubscriptionEvent = async (locale, source) => {
  const response = await $fetch(`/middleware/klaviyo/client-unsubscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      source,
      locale,
    }),
  });
  return response;
};

export const klaviyoBackInStockSubscriptionEvent = async (email, locale, variantId) => {
  const response = await $fetch(`/middleware/klaviyo/subscribe-to-product`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      locale,
      variantId,
    }),
  });
  return response;
};

export const klaviyoProfileUpdateEvent = async (email, locale) => {
  const response = await $fetch(`/middleware/klaviyo/client-profile-import`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      locale,
    }),
  });
  return response;
};

export const klaviyoClientPushEvent = async (email, locale, eventProperties, eventName, force = false) => {
  if (!email) {
    console.error('Error: No email provided.');
    return;
  }

  const { getConsent } = useAxeptio();
  if (!getConsent('__kla_id') && !force) {
    return Promise.resolve();
  }

  const response = await $fetch(`/middleware/klaviyo/client-event`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      locale,
      eventProperties,
      eventName,
    }),
  });
  return response;
};

export const klaviyoGetClientSubscription = async (locale) => {
  const response = await $fetch(`/middleware/klaviyo/client-get-profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ locale }),
  });

  return response;
};
